import { render, staticRenderFns } from "./AssignRegion.vue?vue&type=template&id=fc67aca8&lang=pug"
import script from "./AssignRegion.vue?vue&type=script&lang=js"
export * from "./AssignRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports